"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TodoList {
}
exports.TodoList = TodoList;
class Todo {
    constructor() {
        this.isComplete = false;
    }
}
exports.Todo = Todo;
//# sourceMappingURL=Todo.js.map